export class RhythmPatternStrategy {
  generate(ctx, chord, oct, baseDegree, rand, bpb, genre) {
    if (genre === 'jazz') return this._genJazzComp(ctx, chord, oct, baseDegree, rand, bpb);
    if (genre === 'folkAcoustic') return this._genFolkStrum(ctx, chord, oct, baseDegree, rand, bpb);
    if (genre === 'lofi') return this._genLofiChords(ctx, chord, oct, baseDegree, rand, bpb);
    return this._genRhythm(ctx, chord, oct, baseDegree, rand, bpb);
  }

  _genRhythm(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    if (rand() < 0.33) {
      for (let b = 0.5; b < bpb; b += 1) {
        if (rand() < 0.7) {
          const chordTone = chord[Math.floor(rand() * chord.length)];
          pattern.push({ beat: b, note: ctx.noteFromSemitone(chordTone, oct), duration: 0.15 + rand() * 0.12 });
        }
      }
    } else if (rand() < 0.66) {
      const beats = [0, Math.floor(bpb / 2) + 0.5, bpb - 1];
      beats.forEach(b => {
        if (b < bpb) {
          const chordTone = chord[Math.floor(rand() * chord.length)];
          pattern.push({ beat: b, note: ctx.noteFromSemitone(chordTone, oct), duration: 0.2 + rand() * 0.15 });
        }
      });
    } else {
      for (let i = 0; i < Math.min(chord.length, bpb); i++) {
        pattern.push({
          beat: i * (bpb / Math.min(chord.length, bpb)),
          note: ctx.noteFromSemitone(chord[i % chord.length], oct),
          duration: 0.2 + rand() * 0.2,
        });
      }
    }
    if (pattern.length === 0) pattern.push({ beat: 0.5, note: ctx.noteFromSemitone(chord[0], oct), duration: 0.2 });
    return pattern;
  }

  _genJazzComp(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    const templates = [[0, 1.5], [0, 1.5, 3], [0.5, 1, 2.5, 3], [0, 2, 2.5]];
    const template = templates[Math.floor(rand() * templates.length)];
    for (const b of template) {
      if (b >= bpb) continue;
      const numTones = 2 + Math.floor(rand() * 2);
      for (let t = 0; t < numTones && t < chord.length; t++) {
        pattern.push({ beat: b + t * 0.02, note: ctx.noteFromSemitone(chord[t], oct), duration: 0.15 + rand() * 0.2 });
      }
    }
    return pattern;
  }

  _genFolkStrum(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    for (let beat = 0; beat < bpb; beat++) {
      if (rand() < 0.8) {
        for (let t = 0; t < Math.min(3, chord.length); t++) {
          pattern.push({ beat: beat + t * 0.03, note: ctx.noteFromSemitone(chord[t], oct), duration: 0.2 + rand() * 0.15 });
        }
      }
      if (rand() < 0.5) {
        const upTone = chord[Math.floor(rand() * chord.length)];
        pattern.push({ beat: beat + 0.5, note: ctx.noteFromSemitone(upTone, oct), duration: 0.1 + rand() * 0.1 });
      }
    }
    return pattern;
  }

  _genLofiChords(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    const hits = 1 + Math.floor(rand() * 3);
    for (let i = 0; i < hits; i++) {
      const beat = i === 0 ? 0 : rand() * bpb;
      for (let t = 0; t < Math.min(3, chord.length); t++) {
        pattern.push({ beat: beat + t * 0.02, note: ctx.noteFromSemitone(chord[t], oct), duration: 0.8 + rand() * 0.6 });
      }
    }
    return pattern;
  }
}
